import * as types from "./types";

export const signOut = backUrl => ({
  type: types.SIGN_OUT,
  payload: {
    backUrl
  }
});

export const manualSignIn = token => ({
  type: types.MANUAL_SIGN_IN,
  payload: {
    token
  }
});

export const unauthenticationRedirect = (data, backUrl) => ({
  type: types.UNAUTHENTICATION_REDIRECT,
  payload: {
    backUrl,
    data
  }
});

export const authenticationRedirect = (data, backUrl) => ({
  type: types.AUTHENTICATION_REDIRECT,
  payload: {
    backUrl,
    data
  }
});



// WEBPACK FOOTER //
// ./src/modules/user/auth/actions.js